import { render, staticRenderFns } from "./top_approver.vue?vue&type=template&id=1e77edb4"
import script from "./top_approver.vue?vue&type=script&lang=js"
export * from "./top_approver.vue?vue&type=script&lang=js"
import style0 from "./top_approver.vue?vue&type=style&index=0&id=1e77edb4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports